import { EyeFilled, FormOutlined } from "@ant-design/icons";
import { Card, Col, Row, Switch, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import Notification from "../../../components/shared/Notification";

import { COLORS } from "../../../constants";
import { changeUserStatus } from "../../http-request/user";
import styles from "./styles/ViewAccounts.module.css";

const { Text } = Typography;

const ViewAccounts = ({ loadAccounts = async () => {}, accounts = [] }) => {
  const navigate = useNavigate();

  const changeStatus = async (id, checked) => {
    const token = localStorage.getItem("token");
    await changeUserStatus(id, checked, token).then(async (res) => {
      if (res?.didUpdate) {
        await loadAccounts();
        Notification("User successfully change status", "", "success");
      }
    });
  };
  return (
    <>
        {accounts.length > 0 ? (
        accounts.map((account, index) => {
          index += 1;
          return (
            <Row key={index} align="middle" gutter={10}>
              <Col span={15}>
                <Card
                  size="small"
                  style={{
                    width: "100%",
                    backgroundColor:
                      index % 2 ? COLORS.white : COLORS.lightGray1,
                  }}
                >
                  <Text
                    className={styles.alignLeft}
                  >{`${index}. ${account.firstname} ${account.lastname}`}</Text>
                </Card>
              </Col>
              <Col span={3}>
                <EyeFilled
                  onClick={() =>
                    navigate(
                      `/v2/Administrator/accounts/user/details/${account._id}`,
                      {
                        state: account,
                      }
                    )
                  }
                />
              </Col>
              <Col span={3}>
                <Switch
                  checked={account.isActive}
                  onChange={async (checked) =>
                    changeStatus(account._id, checked)
                  }
                  size="small"
                />
              </Col>
            </Row>
          );
        })
      ) : (
        <Row className={"row-darken"} justify="center" align="center">
          <Text> Nothing to show here ...</Text>
        </Row>
      )}
    </>
  );
};

export default ViewAccounts;
